import React, { useState, useEffect } from 'react';
import { Link, useParams } from 'react-router-dom';
import { message } from 'antd';
import { URLs } from '../../../constants/apiEndpoints';
import { publicAxiosInstance } from '../../../services/createAxiosInstance';
import {
  Card,
  CardBody,
  CardFooter,
  CardHeader,
  Image,
} from '@nextui-org/react';
import { Spin } from 'antd';
import '../../../styles/article-content.css';
import 'quill/dist/quill.snow.css';

function SingleArticlePage() {
  const [loading, setLoading] = useState(false);
  const [data, setData] = useState(null);

  const { id } = useParams();

  const fetchData = async (id) => {
    setLoading(true);
    try {
      const res = await publicAxiosInstance.get(
        `${URLs.GET_SINGLE_ARTICLE}/${id}`
      );
      const data = res?.data?.article;
      setData(data);
    } catch (error) {
      message.error('Error fetching articles');
      console.error('Error fetching articles:', error);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    fetchData(id);
  }, [id]);

  return (
    <>
      <Spin spinning={loading} fullscreen />
      <div className="flex item-center justify-center">
        <Card className="flex mt-8 sm:mt-[75px] font-poppins max-w-5xl bg-transparent mb-10">
          <CardHeader className="block">
            <h2 className="text-3xl md:text-5xl font-bold text-gray-200 font-poppins lg:leading-normal">
              {' '}
              {data?.articleName}
            </h2>
            <p className="text-lg mb-1 mt-3 font-normal text-gray-400 font-poppins  capitalize">
              {new Date(data?.updatedAt).toLocaleDateString()} | by editor
            </p>
          </CardHeader>
          <CardBody className="block">
            <Image
              loading="lazy"
              alt="Article name"
              src={data?.image?.[0]?.url || ''}
              className="w-full"
            ></Image>

            <div
              className="article-content mb-1 mt-3 font-poppins text-gray-100 leading-relaxed"
              dangerouslySetInnerHTML={{ __html: data?.description }}
            />
          </CardBody>
          <CardFooter></CardFooter>
        </Card>
      </div>
    </>
  );
}

export default SingleArticlePage;
